// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1NCZV","right":"styles_right__2mbDF"};